import i18n from "@/i18n";
import { EscrowRequestStates } from "../data/enums/escrowRequestStates";

/**Статус заявки на открытие Эскроу счета. */
export default function escrowRequestState(escrowRequestState: EscrowRequestStates): string {
  let state: string = "";
  switch (escrowRequestState) {
    case EscrowRequestStates.UnderConsideration:
      state = i18n.t("main.escrowRequest.states.underConsideration").toString();
      break;
    case EscrowRequestStates.Canceled:
      state = i18n.t("main.escrowRequest.states.canceled").toString();
      break;
    case EscrowRequestStates.ContractPrepared:
      state = i18n.t("main.escrowRequest.states.contractPrepared").toString();
      break;
    case EscrowRequestStates.ContractExecuting:
      state = i18n.t("main.escrowRequest.states.contractExecuting").toString();
      break;
    default:
      state = "";
      break;
  }

  return state;
}
